export default {
  data() {
    return {
      helperText: ''
    }
  },
  watch: {
    helperText() {
      this.$store.commit('setHelperType', this.helperText)
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/helpertext.js